export enum MultiSelectMode {
    EDIT_VIEW = 0,
    SIMULATION_VIEW = 1,
}